<template>
	<div style="display: flex">

		<v-card elevation="2" class="controles" style="width: 30px; border: 1px solid silver; display: flex; flex-direction: column; justify-content: center; align-items: center; margin: 5px 0; visibility: hidden;">

			<v-tooltip right v-if="cantidadDeElementos > 0 && posición > 0">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon small v-bind="attrs" v-on="on" @click="subir">
						<v-icon>mdi-arrow-up-bold</v-icon>
					</v-btn>
				</template>
				<span>Mover este campo hacia arriba</span>
			</v-tooltip>

			<v-tooltip right>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon small v-bind="attrs" v-on="on" @click="eliminar">
						<v-icon>mdi-delete</v-icon>
					</v-btn>
				</template>
				<span>Eliminar este campo</span>
			</v-tooltip>

			<v-tooltip right v-if="cantidadDeElementos > 0 && posición+1 < cantidadDeElementos">
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon small v-bind="attrs" v-on="on" @click="bajar">
						<v-icon>mdi-arrow-down-bold</v-icon>
					</v-btn>
				</template>
				<span>Mover este campo hacia abajo</span>
			</v-tooltip>

		</v-card>

		<div style="flex-grow: 1; padding: 0 5px">
			<input type="text" maxlength="80" v-model="value.título" placeholder="Escribe aquí el título" class="titulo-campo">

			<input v-if="value.tipo === 'texto'" type="text" :id="`iden${value.identificador}`" :name="`iden${value.identificador}`" maxlength="255" disabled>

			<input v-else-if="value.tipo === 'correo'" type="email" :id="`iden${value.identificador}`" :name="`iden${value.identificador}`" disabled>

			<input v-else-if="value.tipo === 'teléfono'" type="tel" :id="`iden${value.identificador}`" :name="`iden${value.identificador}`" disabled>

			<textarea v-else-if="value.tipo === 'texto_largo'" :id="`iden${value.identificador}`" :name="`iden${value.identificador}`" maxlength="3000" rows="4" disabled></textarea>

			<div v-else-if="value.tipo === 'lista_desplegable'" class="select">
				<select :id="`iden${value.identificador}`" :name="`iden${value.identificador}`" disabled>
					<option value=""></option>
					<option v-for="(o, i) in value.opciones" :key="`opcn${i}`" :value="i">{{ o.descripción }}</option>
				</select>
				<span></span>
			</div>

			<div v-else>[ERROR]</div>

		</div>

	</div>
</template>

<script>

export default {
  name: 'ParteFormularioElemento',

	props: {
		value: {
			type: Object,
			default: function() {
				return {
					tipo: 'texto',
					título: '',
					identificador: Math.random().toString().split('.')[1],
					opciones: []
				}
			}
		},
		cantidadDeElementos: {
			type: Number,
			default: 0
		},
		posición: {
			type: Number,
			default: -1
		},
	},

	methods: {
		eliminar: function() {
			this.$emit('eliminar')
		},
		subir: function() {
			this.$emit('subir')
		},
		bajar: function() {
			this.$emit('bajar')
		},
	}

};

</script>

<style scoped>

input[disabled], textarea[disabled], select[disabled] {
	font-size: 0.8em;
}

.titulo-campo {
	border: none;
	padding: 0;
	margin: 0;
	outline: 0;
	width: unset;
	border-bottom: 1px dashed transparent;
}

.titulo-campo:hover, .titulo-campo:focus {
	border-bottom: 1px dashed silver;
}

.parte:hover .controles {
	visibility: unset !important;
}

</style>